import { render, staticRenderFns } from "./uploadVideoImg.vue?vue&type=template&id=13f4072b&scoped=true&"
import script from "./uploadVideoImg.vue?vue&type=script&lang=js&"
export * from "./uploadVideoImg.vue?vue&type=script&lang=js&"
import style0 from "./uploadVideoImg.vue?vue&type=style&index=0&id=13f4072b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f4072b",
  null
  
)

export default component.exports